import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'demo',
  appClientId: '5r3apeuit7vtjqeo12p69jupgl',
  region: 'us-west-2',
  identityPoolId: 'us-west-2:ee35badb-989a-4953-a511-222a3d6068fc',
  userPoolId: 'us-west-2_cb9s0wtxV',
  domain: 'drift-prod.auth.us-west-2.amazoncognito.com',
  driftApi: 'https://x21mucwl8c.execute-api.us-west-2.amazonaws.com',
  redirectSignIn: 'https://demo.drift.slalom.com/home',
  redirectSignOut: 'https://demo.drift.slalom.com/home',
  features: {
    enablePersonasManagement: true,
    enableSystemPrompts: true,
    enableReviewers: true,
    enableNewAdvisor: true,
    enableOldAdvisor: false,
    enableSampleStyles: false,
    enableLibrary: false
  },
  enableMocks: false
};
